import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import React, { Component } from 'react';

import { ExerciseSearchItem } from '../../api/exercises.interface';
import { withSmallScreenCheck, WithSmallScreenCheckProps } from '../../common/hooks/withSmallScreenCheck';
import ExerciseResultCard from './ExerciseResultCard';
import ExerciseResultsRow from './ExerciseResultsRow';

interface ComponentProps {
    deletingTag?: number;
    items: ExerciseSearchItem[];
    selectedExerciseTags?: number[];
    selectionMode: 'none' | 'single' | 'multiple';
    onDeleteExercise: (item: ExerciseSearchItem) => void;
    onEditExercise: (index: number) => void;
    onSelectExercise?: (item: ExerciseSearchItem) => void;
}

type Props = ComponentProps & WithSmallScreenCheckProps;

class ExerciseResultsTable extends Component<Props> {
    render() {
        const { deletingTag, isSmallScreen, items, selectedExerciseTags, selectionMode, onDeleteExercise, onEditExercise, onSelectExercise } = this.props;

        if (isSmallScreen) {
            return (
                <Box sx={{ display: 'grid', gap: 2 }}>
                    {items.map((item) => (
                        <ExerciseResultCard
                            deletingTag={deletingTag}
                            item={item}
                            key={item.index}
                            onDeleteExercise={onDeleteExercise}
                            onEditExercise={onEditExercise}
                            onSelectExercise={onSelectExercise}
                            selectedExerciseTags={selectedExerciseTags}
                            selectionMode={selectionMode}
                        />
                    ))}
                </Box>
            );
        }

        return (
            <TableContainer component={Paper} sx={{ borderRadius: 3 }} variant="outlined">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Exercise Name</TableCell>
                            <TableCell>Tag</TableCell>
                            <TableCell>Level</TableCell>
                            <TableCell>Plan</TableCell>
                            <TableCell>Reps</TableCell>
                            <TableCell>Weight Range</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.map((item) => (
                            <ExerciseResultsRow
                                deletingTag={deletingTag}
                                item={item}
                                key={item.index}
                                onDeleteExercise={onDeleteExercise}
                                onEditExercise={onEditExercise}
                                onSelectExercise={onSelectExercise}
                                selectedExerciseTags={selectedExerciseTags}
                                selectionMode={selectionMode}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }
}

export default withSmallScreenCheck(ExerciseResultsTable);